var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "product-statistics area"
  }, [_c("h3", [_vm._v("AI能力全面开放")]), _c("a-row", [_c("a-col", {
    attrs: {
      span: 8,
      align: "center"
    }
  }, [_c("div", {
    staticClass: "statistics-item"
  }, [_c("div", {
    staticClass: "left-img"
  }, [_c("img", {
    attrs: {
      src: require("../../../../assets/images/persoanl/tec.png"),
      alt: ""
    }
  })]), _c("div", {
    staticClass: "right"
  }, [_c("div", {
    staticClass: "count"
  }, [_c("count-to", {
    ref: "yearRef",
    attrs: {
      startVal: _vm.startVal,
      endVal: _vm.yearsCount,
      duration: 2000,
      autoplay: false
    }
  }), _c("span", [_vm._v("年")])], 1), _c("h4", [_vm._v("技术沉淀")])])])]), _c("a-col", {
    attrs: {
      span: 8
    }
  }, [_c("div", {
    staticClass: "statistics-item"
  }, [_c("div", {
    staticClass: "left-img"
  }, [_c("img", {
    attrs: {
      src: require("../../../../assets/images/persoanl/user.png"),
      alt: ""
    }
  })]), _c("div", {
    staticClass: "right"
  }, [_c("div", {
    staticClass: "count"
  }, [_c("count-to", {
    ref: "userRef",
    attrs: {
      startVal: _vm.startVal,
      endVal: _vm.usersCount,
      duration: 2000,
      autoplay: false
    }
  }), _c("span", [_vm._v("亿")])], 1), _c("h4", [_vm._v("海量用户使用")])])])]), _c("a-col", {
    attrs: {
      span: 8
    }
  }, [_c("div", {
    staticClass: "statistics-item"
  }, [_c("div", {
    staticClass: "left-img"
  }, [_c("img", {
    attrs: {
      src: require("../../../../assets/images/persoanl/center.png"),
      alt: ""
    }
  })]), _c("div", {
    staticClass: "right"
  }, [_c("div", {
    staticClass: "count"
  }, [_c("count-to", {
    ref: "technologyRef",
    attrs: {
      startVal: _vm.startVal,
      endVal: _vm.technologyCount,
      duration: 2000,
      autoplay: false
    }
  }), _c("span", [_vm._v("项")])], 1), _c("h4", [_vm._v("核心技术服务")])])])])], 1), _c("div", {
    staticClass: "total"
  }, [_c("span", [_vm._v("同花顺AI服务累计调用量：")]), _c("count-to", {
    ref: "apiRef",
    attrs: {
      startVal: _vm.startVal,
      endVal: _vm.apiUseCount,
      duration: 2000,
      autoplay: false
    }
  }), _c("span", [_vm._v("次")])], 1)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };